<h1 mat-dialog-title align="center">Create New Client Translation</h1>
<div class="container">
	<div mat-dialog-content>
		<div>
			<form [formGroup]="createNewTranslationRecordForm">
				<div id="translation-associations">
					<h2>Translation Association:</h2>

					<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
						<div fxFlex="50%">
							<!--Client Type Selection-->
							<ahs-select
								id="clientType"
								[ahsFormGroup]="createNewTranslationRecordForm"
								appearance="outline"
								[options]="clientTypeOptions"
								label="Client Type Id"
							>
							</ahs-select>
						</div>
						<!--Portal Page Name Selection-->
						<div fxFlex="50%">
							<ahs-select
								id="portalPageName"
								[ahsFormGroup]="createNewTranslationRecordForm"
								[showEmptyOption]="true"
								appearance="outline"
								label="Portal Page Name"
								[options]="portalPageNameOptions"
							>
							</ahs-select>
						</div>
					</div>
				</div>

				<div id="Language Information">
					<h2>Language Information:</h2>

					<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
						<div fxFlex="50%">
							<!--Client Type Selection-->
							<ahs-select
								id="languageCode"
								[ahsFormGroup]="createNewTranslationRecordForm"
								appearance="outline"
								[options]="languageCodeOptions"
								label="Language Code"
							>
							</ahs-select>
						</div>
						<!--Portal Page Name Selection-->
						<div fxFlex="50%">
							<ahs-text
								id="translationKey"
								[ahsFormGroup]="createNewTranslationRecordForm"
								appearance="outline"
								label="Translation Key"
							>
							</ahs-text>
						</div>
					</div>

					<!--Create all language translations with key creation?-->
					<div>
						<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
							<div fxFlex="50%">
								Automatically create records for all contract languages?
								<mat-checkbox
									id="createRecordsForAllLanguages"
									formControlName="createRecordsForAllLanguages"
								>
								</mat-checkbox>
							</div>
						</div>
					</div>
				</div>

				<div id="Translated Text">
					<h2>Translated Text:</h2>

					<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
						<div fxFlex="100%">
							<!--Client Type Selection-->
							<ahs-textarea
								id="translatedText"
								type="text"
								tabOrder="1"
								[ahsFormGroup]="createNewTranslationRecordForm"
								label="Translated Text"
								appearance="outline"
								floatLabel="floatLabel"
							>
							</ahs-textarea>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>

	<!--Action Buttons-->
	<div mat-dialog-actions>
		<div>
			<div fxLayoutAlign="row stretch" fxLayoutGap="20px">
				<!--Create Record Button-->
				<div fxFlex="50%">
					<button
						mat-raised-button
						[disabled]="!this.createNewTranslationRecordForm.valid"
						(click)="submitCreateRecordRequest()"
					>
						Create Translation Record
					</button>
				</div>
				<div fxFlex="50%">
					<button mat-raised-button class="danger-btn" (click)="closeTranslationCreationModal()">
						Close
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
